import React, { useEffect, useRef, useState } from "react";
import { SectionNavigation } from "../../../components/main/sectionNavigation";
import { Section1 } from "./section/section_1";
import { Section2 } from "./section/section_2";
import { Section3 } from "./section/section_3";
import { Section4 } from "./section/section_4";
import { Section5 } from "./section/section_5";
import { Section6 } from "./section/section_6";
export const Main = () => {
    const scrollRef = useRef<any>([])
    const [scrollNumber, setScrollNumber] = useState<number>(0)
    const handleScroll = (index:number) => {
      const targetElement = scrollRef.current[index];
      if (targetElement && window.innerWidth > 768) {
        if(index === 1){window.scrollTo({top: targetElement.offsetTop + (-250),behavior: 'smooth'});}
        else if(index === 2){window.scrollTo({top: targetElement.offsetTop + (-250),behavior: 'smooth'});}
        else if(index === 3){window.scrollTo({top: targetElement.offsetTop + (-180),behavior: 'smooth'});}
        else if(index === 4){window.scrollTo({top: targetElement.offsetTop + (-270),behavior: 'smooth'});}
        else if(index === 5){window.scrollTo({top: targetElement.offsetTop + (-270),behavior: 'smooth'});}
        else{window.scrollTo({top: targetElement.offsetTop,behavior: 'smooth'});}
      }else if(targetElement && window.innerWidth <= 768){
        if(index === 1){window.scrollTo({top: targetElement.offsetTop + (-600),behavior: 'smooth'});}
        else if(index === 2){window.scrollTo({top: targetElement.offsetTop + (-100),behavior: 'smooth'});}
        else if(index === 3){window.scrollTo({top: targetElement.offsetTop + (-100),behavior: 'smooth'});}
        else if(index === 4){window.scrollTo({top: targetElement.offsetTop + (-130),behavior: 'smooth'});}
        else if(index === 5){window.scrollTo({top: targetElement.offsetTop + (-150),behavior: 'smooth'});}
        else{window.scrollTo({top: targetElement.offsetTop,behavior: 'smooth'});}
      }
    }
    // useEffect(() => {
    //   const handleScrollEvent = () => {
    //     let currentIndex = -1;
    //     for (let i = 0; i < scrollRef.current.length; i++) {
    //       const targetElement = scrollRef.current[i];
    //       if (targetElement) {
    //         const boundingBox = targetElement.getBoundingClientRect();
    //         const isInViewport =
    //           boundingBox.top <= window.innerHeight && boundingBox.bottom >= 0;
  
    //         if (isInViewport) {
    //           currentIndex = i;
    //           break;
    //         }
    //       }
    //     }
    //     if (currentIndex !== -1) {
    //       console.log("Current Index:", currentIndex);
    //       setScrollNumber(currentIndex);
    //     }
    //   };
    //   window.addEventListener("scroll", handleScrollEvent);
    //   return () => {
    //     window.removeEventListener("scroll", handleScrollEvent);
    //   };
    // }, []);
    return(
        <>
        <Section1 scroll={scrollRef}/>
        <Section2 scroll={scrollRef}/>
        <Section3 scroll={scrollRef}/>
        <Section4 scroll={scrollRef}/>
        <Section5 scroll={scrollRef}/>
        <Section6 scroll={scrollRef}/>
        <SectionNavigation onScroll={handleScroll} scrollNumber={scrollNumber} setScrollNumber={setScrollNumber}/>
        </>
    )
}